
import { Component, Vue } from "nuxt-property-decorator";
import { tabExitHandler } from "~/operations/meta-helper-functions";

@Component({
  components: {},
})
export default class ShopLayout extends Vue {
  head() {
    return {
      htmlAttrs: { lang: "de" },
    };
  }
  mounted() {
    this.detectUserLeftTab();
  }
  detectUserLeftTab() {
    tabExitHandler(this);
  }
}
